import script from "./HistoriaClinica.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoriaClinica.vue?vue&type=script&setup=true&lang=js"

import "./HistoriaClinica.vue?vue&type=style&index=0&id=65e7851c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e7851c"]])

export default __exports__